// Mobile design tokens — INDUSTRIAL direction.
// Mirrors the values in application.css :root so mobile components stay in sync
// with the rest of the app while keeping a typed JS object for inline styles.
//
// Stages, tags, products, etc. are NOT in this file — they're per-account
// configuration loaded from the database and passed down as props.

export const T = {
  bg: "#EDEEEE",
  surface: "#FFFFFF",
  surfaceAlt: "#E2E5E8",
  ink: "#14181B",
  inkSoft: "#5A636B",
  inkMuted: "#8A939B",
  border: "#C9CDD2",
  borderSoft: "#DDE1E5",
  divider: "#E2E5E8",

  accent: "#E8541C",
  accentInk: "#FFFFFF",
  accentSoft: "#FCE3D6",
  accentBorder: "#F5B89C",

  danger: "#B92E1F",
  dangerSoft: "#F4D6D2",
  success: "#2C7A4D",
  successSoft: "#D6E9DE",
  warning: "#D4A015",
  warningSoft: "#F7E8B8",

  fontDisplay: '"IBM Plex Sans", "Inter", system-ui, sans-serif',
  fontBody:    '"IBM Plex Sans", "Inter", system-ui, sans-serif',
  fontMono:    '"IBM Plex Mono", ui-monospace, "SF Mono", monospace',

  radius: 4,
  radiusLg: 6,

  shadowSm:    "0 1px 0 rgba(20, 24, 27, 0.04)",
  shadowMd:    "0 2px 0 rgba(20, 24, 27, 0.06)",
  shadowLg:    "0 8px 24px -8px rgba(20, 24, 27, 0.18)",
  shadowSheet: "0 -2px 0 rgba(20, 24, 27, 0.08)",

  hitSize: 44,
  tabBarHeight: 68,
  headerHeight: 56,
} as const

export type Theme = typeof T

// A stage as it travels over the wire from `Current.account.stages`.
export interface Stage {
  id: string | number
  name: string
  color: string
  position?: number
}

/**
 * Choose a contrasting text color for a given hex background.
 * Mirrors the helper in components/StageChip.tsx so the mobile UI looks
 * identical to the desktop chip when rendering account-configured stages.
 */
export function contrastInk(hexColor: string): string {
  const hex = hexColor.replace("#", "")
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5 ? "#14181B" : "#FFFFFF"
}

/** Slightly transparent variant of a stage color, for "soft" badge backgrounds. */
export function softVariant(hexColor: string, alpha = 0.18): string {
  const hex = hexColor.replace("#", "")
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
